// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "app") return "css/app" + __webpack_require__.h() + ".css";
	// return url for filenames based on template
	return "css/" + chunkId + "" + __webpack_require__.h() + ".css";
};